import styled from 'styled-components'

export const Container = styled.div`
  .ant-table-tbody tr {
    z-index: 999 !important;
  }
`
